import React from "react";
import "../styles/styles.css";

function ContactPage() {
  return (
    <div className="contact-page">
      <h1 className="contact-title">Contacta con nosotros</h1>
      <div className="contact-container">
        {/* Sección de contacto */}
        <div className="contact-info">
          <h2>Ponte en contacto</h2>
          <p>
            ¿Tiene preguntas? Nos encantaría saber de usted. Envíanos un mensaje y
            responderemos lo antes posible.
          </p>
          <ul className="contact-details">
            <li>
              <i className="fas fa-phone"></i> 321-5886925
            </li>
            <li>
              <i className="fas fa-envelope"></i> cybersofiacontacto@gmail.com
            </li>
            <li>
              <i className="fas fa-map-marker-alt"></i> Cl. 5 #4-82
            </li>
          </ul>
        </div>
        {/* Formulario de contacto */}
        <div className="contact-form">
          <h2>Envíanos un mensaje</h2>
          <form>
            <input
              type="text"
              placeholder="Su nombre"
              className="form-input"
              required
            />
            <input
              type="email"
              placeholder="Tu correo electrónico"
              className="form-input"
              required
            />
            <textarea
              placeholder="Tu mensaje"
              className="form-textarea"
              rows="5"
              required
            ></textarea>
            <button type="submit" className="form-button">
            Enviar mensaje
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ContactPage;
